var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OfferedAsType } from '../offerings/offering.dto';
import * as currencySymbolMap from 'currency-symbol-map/map';
import { PriceUtils } from './price-dto-factory';
var currencyFixesOverrides = {
    KZT: '₸',
    LBP: 'ل.ل.',
};
var fixedCurrencySymbolMap = __assign(__assign({}, currencySymbolMap), currencyFixesOverrides);
var PriceDomain = /** @class */ (function () {
    function PriceDomain(priceDto, offeredAs) {
        this.priceDto = priceDto;
        this.offeredAs = offeredAs;
    }
    Object.defineProperty(PriceDomain.prototype, "text", {
        get: function () {
            if (this.shouldShowPlanText()) {
                return this.priceDto.displayTextForPlan;
            }
            if (this.shouldShowOfferingPrice()) {
                var symbol = fixedCurrencySymbolMap[this.priceDto.currency];
                return "" + symbol + this.formattedPrice();
            }
            if (this.shouldShowFreeOfferingText()) {
                return this.priceDto.priceText;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    PriceDomain.prototype.shouldShowPlanText = function () {
        return (this.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) > -1 &&
            this.priceDto.displayTextForPlan);
    };
    PriceDomain.prototype.shouldShowOfferingPrice = function () {
        return !this.priceDto.isFree && this.priceDto.price;
    };
    PriceDomain.prototype.shouldShowFreeOfferingText = function () {
        return (this.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) <= -1 &&
            this.priceDto.isFree);
    };
    PriceDomain.prototype.formattedPrice = function () {
        var price = Number(this.priceDto.price);
        return price.toFixed(PriceUtils.getFractionDigits(price));
    };
    return PriceDomain;
}());
export { PriceDomain };
//# sourceMappingURL=price-domain.js.map